import React from 'react';
import SvgRender from 'common/components/general/SvgRender';

import PageTitle from 'common/components/general/PageTitle';

import { Col, Button, Row } from 'reactstrap';
import _isEqual from 'lodash/isEqual';

import dots from 'common/assets/svg/actions/three-dots.svg';

const TableActions = React.memo(
  ({ actions, title = '', dropdown, className = 'mt-1' }) => {
    const ActionContent = ({ action }) => {
      switch (action.type) {
        case 'actions':
          return (
            <Button
              color={'link'}
              className={`page-layout--table-action type-${action.type} d-inline-flex align-items-center justify-content-center`}
            >
              <SvgRender src={dots} style={{ height: 18, width: 18 }} />
            </Button>
          );
        default:
          return (
            <Button
              color={action.color ? action.color : 'link'}
              className={`page-layout--table-action type-${action.type} d-inline-flex align-items-center justify-content-center`}
              onClick={action.onClick}
            >
              {action.text || ''}
            </Button>
          );
      }
    };

    return (
      <Row>
        {title ? (
          <Col className={className}>
            <PageTitle
              className="mb-0 mt-0"
              render={() => (
                <div className="d-flex align-items-center">
                  {title}
                  {dropdown ? (
                    <div className="ms-1 d-flex align-items-center fw-bold">/ {dropdown}</div>
                  ) : null}
                </div>
              )}
            />
          </Col>
        ) : null}
        {actions && actions.length ? (
          <Col className="d-flex align-items-center justify-content-end">
            {actions.map((action, index) => (
              <div key={index} className="ms-3">
                <ActionContent key={action.type} action={action} />
              </div>
            ))}
          </Col>
        ) : null}
      </Row>
    );
  },
  (prevProps, nextProps) => !_isEqual(prevProps, nextProps)
);
TableActions.displayName = 'TableActions';

export default TableActions;
